<template>
    <div>
        <!-- my account start  -->
        <section class="main_content_area pt-30">
            <div class="container extra-view">   
                <div class="account_dashboard">
                    <div class="row">
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <!-- Nav tabs -->
                            <div class="dashboard_tab_button">
                                <ul role="tablist" class="nav flex-column dashboard-list">
                                    <li> <a href="#orders" data-bs-toggle="tab" class="nav-link active">Đơn mua</a></li>
                                    <li><a href="#receipts" data-bs-toggle="tab" class="nav-link">Đơn xuất</a></li>
                                    <li><a href="#returns" data-bs-toggle="tab" class="nav-link">Trả hàng</a></li>
                                    <li><a href="#recharges" data-bs-toggle="tab" class="nav-link">Thanh toán</a></li>
                                    <li><a href="#account-details" data-bs-toggle="tab" class="nav-link">Tài khoản</a></li>
                                    <li><a href="#" class="nav-link only-desktop" @click="logout">Đăng xuất</a></li>
                                </ul>
                            </div>    
                        </div>
                        <div class="col-sm-12 col-md-10 col-lg-10">
                            <!-- Tab panes -->
                            <div class="tab-content dashboard_content">
                                <div class="tab-pane fade show active" id="orders">
                                    <h3>Danh sách đơn hàng</h3>
                                    <div class="row row-padding">
                                        <div class="col-12">
                                            <v-select v-model="selectedOrderStatus" :items="order_status" item-text="name" item-value="value" label="Lọc trạng thái đơn" class="input-group--focused only-mobile" @change="filter_data()" clearable></v-select>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <mh-date-picker plabel="Từ ngày" class="input-group--focused date-picker" v-model="order_start_date" @onChangeDate="order_start_date =$event; filter_data()"></mh-date-picker>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <mh-date-picker plabel="Đến ngày" class="input-group--focused date-picker" v-model="order_end_date" @onChangeDate="order_end_date =$event; filter_data()"></mh-date-picker>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <hpo-filter :headers="order_headers" :viewName="'account_orders'" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                                        <v-data-table :headers="order_headers" :items="orders" :options.sync="pagination" :server-items-length="total_order" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="elevation-1 v-order-table">
                                            <template v-slot:item="{ item }">
                                                <tr>
                                                    <td class="text-start">{{ item.id }}</td>
                                                    <td><img :src="'/'+item.path" alt="" style="height: 56px"></td>
                                                    <td class="text-start">
                                                        <h5><a target="_blank" :href="'/chi-tiet-san-pham/' + item.product_id">{{ item.name }}</a></h5>
                                                        <h6>Mã sp: <b>{{ item.product_code }}</b></h6>
                                                        <template v-if="item.options && item.options.length > 0">
                                                            <ul>
                                                                <li v-for="op in item.options" :key="op.order_product_id">
                                                                    {{ op.option_label }} (SL: {{ op.qty }})
                                                                </li>
                                                            </ul>
                                                        </template>
                                                        <h6 v-if="item.admin_note">Admin note: <b class="text-red">{{ item.admin_note }}</b></h6>
                                                    </td>
                                                    <td class="text-end">{{ item.qty | currency }}</td>
                                                    <td class="text-start">{{ item.created_at | display_date }}</td>
                                                    <td class="text-start" v-bind:style="{'color': display_color(item.status, order_status)}" >{{ item.status | display_value(order_status) }}</td>
                                                    <td class="text-start">{{ item.shipment_status | display_value(order_shipment_status) }}</td>
                                                    <td class="text-end">{{ item.total | currency }}</td>
                                                    <td class="text-start">{{ item.note }}</td>
                                                    <td class="text-center">
                                                        <v-icon medium class="mr-2" @click="openItem(item)" :disabled="item.status != 'chua_mua_hang'">edit</v-icon>
                                                        <v-icon medium class="mr-2"  @click="deleteItem(item.id)" :disabled="item.status != 'chua_mua_hang'">delete</v-icon>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-slot:body.append v-if="summary_order">
                                                <tr class="total-summary-td">
                                                    <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                                                    <td class="text-end font-weight-bold">{{ summary_order.total_qty | currency}}</td>
                                                    <td class="text-end font-weight-bold"></td>
                                                    <td class="text-end font-weight-bold"></td>
                                                    <td class="text-end font-weight-bold"></td>
                                                    <td class="text-end font-weight-bold">{{ summary_order.total_amount | currency}}</td>
                                                    <td></td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </div>
                                    <div class="row row-padding only-mobile" v-if="summary_order">
                                        <div class="col-12" style="padding-top: 20px !important;">
                                            <h5 class="text-red">Tổng đơn: <b>{{ total_order | currency}}</b> ----- Tổng SP: <b>{{ summary_order.total_qty | currency}}</b> ----- Tổng tiền: <b>{{ summary_order.total_amount | currency}}</b></h5>
                                        </div>
                                    </div>
                                    <v-list class="v-list-order">
                                        <v-list-item v-for="(item, index) in orders" :key="index">
                                            <v-list-item-content>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <span>{{ item.created_at | display_date }}</span>
                                                    </div>
                                                    <div class="col-4">
                                                        <img :src="'/'+item.path" alt="">
                                                    </div>
                                                    <div class="col-8">
                                                        <p>Mã đơn hàng: <b>{{ item.id }}</b></p>
                                                        <p>Mã sản phẩm: <b>{{ item.product_code }}</b></p>
                                                        <p>Tên sản phẩm: <b>{{ item.name }}</b></p>
                                                    </div>
                                                    <div class="col-12">
                                                        <p>Ghi chú: <b class="text-red">{{ item.note }}</b></p>
                                                        <p>Admin note: <b>{{ item.admin_note }}</b></p>
                                                    </div>
                                                    <div class="col-12">
                                                        <p>Trạng thái: <b v-bind:style="{'color': display_color(item.status, order_status)}">{{ item.status | display_value(order_status) }}</b></p>
                                                        <p>Giao hàng: <b>{{ item.shipment_status | display_value(order_shipment_status)  }}</b></p>
                                                    </div>
                                                    <div class="col-12">
                                                        <p>Thuộc tính:</p>
                                                        <template v-if="item.options && item.options.length > 0">
                                                            <ul>
                                                                <li v-for="op in item.options" :key="op.order_product_id">
                                                                    {{ op.option_label }} (SL: {{ op.qty }})
                                                                </li>
                                                            </ul>
                                                        </template>
                                                        <p>Thành tiền: <b class="text-red">{{ item.total | currency }}</b></p>
                                                    </div>
                                                    <div class="col-12 text-right">
                                                        <v-icon medium class="mr-2" @click="openItem(item)" :disabled="item.status != 'chua_mua_hang'">edit</v-icon>
                                                        <v-icon medium @click="deleteItem(item.id)" :disabled="item.status != 'chua_mua_hang'">delete</v-icon>
                                                    </div>
                                                    <div class="col-12">
                                                        <hr/>
                                                    </div>
                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                    <div class="row only-mobile" v-bind:style="{display: showLoadMoreOrder ? 'block !important' : 'none !important'}">
                                        <div class="col-12" style="text-align: center;">
                                            <button type="submit" class="btn-hcs" @click="load_more_order()">Xem thêm</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="receipts">
                                    <h3>Danh sách đơn xuất</h3>
                                    <div class="table-responsive">
                                        <hpo-filter :headers="receipt_headers" :viewName="'account_receipts'" v-on:applyFilter="applyFilterReceipt" v-on:quickFilter="quickFilterReceipt"></hpo-filter>
                                        <v-data-table :headers="receipt_headers" :items="receipts" :options.sync="receipt_pagination" :server-items-length="total_receipt" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="elevation-1">
                                            <template v-slot:item="{ item }">
                                                <tr>
                                                    <td>HD{{ pad(item.id,6) }}</td>
                                                    <td>{{ item.created_at | display_date }}</td>
                                                    <td class="text-right">{{ item.total | currency }}</td>
                                                    <td class="text-right">{{ item.discount | currency }}</td>
                                                    <td class="text-right">{{ item.amount | currency }}</td>
                                                    <td><a @click="openReceiptDetail(item.id)">Xem</a></td>
                                                </tr>
                                            </template>
                                            <template v-slot:body.append v-if="summary_receipt">
                                                <tr class="total-summary-td">
                                                    <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                                                    <td class="text-end font-weight-bold">{{ summary_receipt.total | currency}}</td>
                                                    <td class="text-end font-weight-bold">{{ summary_receipt.discount | currency}}</td>
                                                    <td class="text-end font-weight-bold">{{ summary_receipt.amount | currency}}</td>
                                                    <td></td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="returns">
                                    <h3>Danh sách trả hàng</h3>
                                    <div class="table-responsive">
                                        <hpo-filter :headers="receipt_headers" :viewName="'account_returns'" v-on:applyFilter="applyFilterReturn" v-on:quickFilter="quickFilterReturn"></hpo-filter>
                                        <v-data-table :headers="receipt_headers" :items="returns" :options.sync="return_pagination" :server-items-length="total_return" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="elevation-1">
                                            <template v-slot:item="{ item }">
                                                <tr>
                                                    <td>HD{{ pad(item.id,6) }}</td>
                                                    <td>{{ item.created_at | display_date }}</td>
                                                    <td class="text-right">{{ item.total | currency }}</td>
                                                    <td class="text-right">{{ item.discount | currency }}</td>
                                                    <td class="text-right">{{ item.amount | currency }}</td>
                                                    <td><a @click="openReturnDetail(item.id)">Xem</a></td>
                                                </tr>
                                            </template>
                                            <template v-slot:body.append v-if="summary_return">
                                                <tr class="total-summary-td">
                                                    <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                                                    <td class="text-end font-weight-bold">{{ summary_return.total | currency}}</td>
                                                    <td class="text-end font-weight-bold">{{ summary_return.discount | currency}}</td>
                                                    <td class="text-end font-weight-bold">{{ summary_return.amount | currency}}</td>
                                                    <td></td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="recharges">
                                    <h3>Danh sách thanh toán</h3>
                                    <div class="table-responsive">
                                        <hpo-filter :headers="recharge_headers" :viewName="'account_recharges'" v-on:applyFilter="applyFilterRecharge" v-on:quickFilter="quickFilterRecharge"></hpo-filter>
                                        <v-data-table :headers="recharge_headers" :items="recharges" :options.sync="recharge_pagination" :server-items-length="total_recharge" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="elevation-1">
                                            <template v-slot:item="{ item }">
                                                <tr>
                                                    <td>TT{{ pad(item.id,6) }}</td>
                                                    <td>{{ item.created_at | display_date }}</td>
                                                    <td>{{ item.trade_content}}</td>
                                                    <td class="text-right">{{ item.amount | currency }}</td>
                                                </tr>
                                            </template>
                                            <template v-slot:body.append v-if="summary_recharge">
                                                <tr class="total-summary-td">
                                                    <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                                                    <td class="text-end font-weight-bold">{{ summary_recharge.amount | currency}}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="account-details">
                                    <h3>Tài khoản</h3>
                                    <div class="login">
                                        <div class="login_form_container">
                                            <div class="account_login_form">
                                                <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                                                    <v-flex lg12>
                                                        <h5>Tiền hàng: <b>{{ customer.total_amount | currency }}</b></h5>
                                                    </v-flex>
                                                    <v-flex lg12>
                                                        <h5>Trả hàng: <b>{{ customer.total_return | currency }}</b></h5>
                                                    </v-flex>
                                                    <v-flex lg12>
                                                        <h5>Thanh toán: <b>{{ customer.total_recharge | currency }}</b></h5>
                                                    </v-flex>
                                                    <v-flex lg12>
                                                        <h5>Công nợ: <b class="text-red">{{ customer.total_debt | currency }}</b></h5>
                                                    </v-flex>
                                                    <v-flex lg12 md12 sm12 xs12>
                                                        <hr/>
                                                    </v-flex>
                                                    <v-flex lg12 md12 sm12 xs12>
                                                        <h5><b>Đổi mật khẩu</b></h5>
                                                    </v-flex>
                                                    <v-flex lg4 md6 sm12>
                                                        <v-text-field v-model="password" type="password" label="Mật khẩu mới" class="input-group--focused"></v-text-field>
                                                        <v-text-field v-model="retype_password" type="password" label="Nhập lại mật khẩu mới" class="input-group--focused"></v-text-field>
                                                    </v-flex>
                                                    <v-flex lg12 md12 sm12 xs12>
                                                        <v-btn @click="changePassword">Cập nhật</v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>          
        </section>          
        <!-- my account end   --> 
        <v-dialog v-model="dialogItem" max-width="700px">
            <v-card v-if="selectedItem">
                <v-card-title>
                <span class="title">Cập nhật đơn hàng #{{ selectedItem.id }}</span>
                </v-card-title>
                <v-card-text>
                <v-container grid-list-md pa-0 v-if="selectedItem.product_detail">
                    <p>Sản phẩm: <b>{{ selectedItem.product_detail.name }}</b></p>
                    <p>Mã sp: <b>{{ selectedItem.product_detail.product_code }}</b></p>
                    <div class="product_option" v-if="selectedItem.product_detail.options && selectedItem.product_detail.options.length > 0">
                        <v-layout row wrap v-for="(op, op_index) in selectedItem.product_detail.options" :key="op_index">
                            <v-flex lg4 md4 sm12>
                                <h4>{{ op.name }}</h4>
                            </v-flex>
                            <v-flex lg8 md8 sm12 v-if="op.position == 0">
                                <ul class="list-inline-1">
                                    <li v-for="(val, val_index) in op.option_values" :key="val_index" v-bind:class="{ 'has_image': op.has_image && val.path, 'active': val.id == selectedFirstOption.id, 'choised': getFirstOptionQty(val.id) > 0}"  @click="selectedFirstOption = val">
                                        <p>{{ val.label }}</p>
                                    </li>
                                </ul>
                            </v-flex>
                            <v-flex lg8 md8 sm12 v-else>
                                <ul class="list-inline-2">
                                    <li v-for="val in op.option_values" :key="val.id" class="number-picker" v-bind:class="{'choised': getOrderOption(selectedFirstOption.id, val.id) > 0}">
                                        <label for="qty">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + val.label }}</label>
                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, val.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, val.option_id, val.id, event)"></v-minusplusfield>
                                    </li>
                                </ul>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="selectedItem.product_detail.options.length == 1 && selectedFirstOption">
                            <v-flex lg4 md4 sm12>
                            </v-flex>
                            <v-flex lg8 md8 sm12>
                                <ul class="list-inline-2">
                                    <li class="number-picker single">
                                        <label for="qty">{{ selectedFirstOption.label }}</label>
                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event)"></v-minusplusfield>
                                    </li>
                                </ul>
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-minusplusfield v-else :min="0" :max="1000000" :value="getOrderOption(0, 0)" @input="event => updateOrderOption(0, 0, 0, 0, event)"></v-minusplusfield>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="editItem">Cập nhật</v-btn>
                <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDetailReceipt" max-width="800px">
            <v-card v-if="selectedReceipt">
                <v-card-title>
                <span class="title">Chi tiết đơn xuất #{{ selectedReceipt.id }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-data-table :headers="detail_header" :items="selectedReceipt.receipt_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.product_code }}</td>
                                    <td>{{ item.product_name }}</td>
                                    <td class="text-right">
                                        {{ item.qty | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.unit_price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.discount | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.line_total | currency }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="printData">In HĐ</v-btn>
                    <v-btn color="red darken-1 white--text" @click="dialogDetailReceipt = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDetailReturn" max-width="800px">
            <v-card v-if="selectedReturn">
                <v-card-title>
                <span class="title">Chi tiết trả hàng #{{ selectedReturn.id }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-data-table :headers="detail_header" :items="selectedReturn.return_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.product_code }}</td>
                                    <td>{{ item.product_name }}</td>
                                    <td class="text-right">
                                        {{ item.qty | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.unit_price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.discount | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.line_total | currency }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogDetailReturn = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { sendErrorNotice, pad } from '@/commons/utils'
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { print_export_receipt } from "@/commons/hpod";
import PlusMinusField from "@/components/PlusMinusField.vue";
import moment from "moment"
export default {
    components: {
        "hpo-filter": Filtering,
        'v-minusplusfield': PlusMinusField,
        "mh-date-picker": MHDatePicker
    },
    data () {
        return {
            viewName: "account",
            selectedFirstOption: {},
            order_options: [],
            pad: pad,
            display_color: display_color,
            order_headers: [
                {
                    text: "ID",
                    value: "orders.id",
                    width: "60px",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ảnh",
                    value: "path",
                    width: "60px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Sản phẩm",
                    value: "product_code",
                    align: 'start',
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Số lượng",
                    value: "qty",
                    align: "end",
                    width: "60px",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày lên đơn",
                    value: "orders.created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Trạng thái",
                    value: "status",
                    filterable: true,
                    values: configs.ORDER_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tình trạng",
                    value: "shipment_status",
                    filterable: true,
                    values: configs.ORDER_SHIPMENT_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "note",
                    align: 'start',
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    value: "",
                    width: "60px",
                }
            ],
            receipt_headers: [{
                    text: "Mã đơn",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng sau giảm",
                    value: "amount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    width: "40px"
                }
            ],
            recharge_headers: [{
                    text: "Mã TT",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Nội dung",
                    value: "trade_content",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                }
            ],
            detail_header: [
                {
                    text: "Mã SP",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "Tên SP",
                    value: "product_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "SL",
                    value: "qty",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Đơn giá",
                    value: "unit_price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giá bán",
                    value: "price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Thành tiền",
                    value: "line_total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                }
            ],
            order_status: configs.ORDER_STATUS,
            order_shipment_status: configs.ORDER_SHIPMENT_STATUS,
            pagination: {...configs.PAGINATION, itemsPerPage: 10},
            receipt_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            return_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            recharge_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            filterReceiptConditions: [],
            filterReturnConditions: [],
            filterRechargeConditions: [],
            quickFilterConditions: [],
            quickFilterReceiptConditions: [],
            quickFilterReturnConditions: [],
            quickFilterRechargeConditions: [],
            selectedItem: null,
            dialogItem: false,
            password: '',
            retype_password: '',
            selectedOrderStatus: '',
            order_start_date: '',
            order_end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dialogDetailReceipt: false,
            dialogDetailReturn: false,
        }
    },
    computed: {
        ...mapState({
            customer: (state) => state.users.selected,
            orders: state => state.orders.all.data,
            total_order: state => state.orders.all.total,
            summary_order: state => state.orders.all.summary,
            receipts: state => state.receipts.all.data,
            total_receipt: state => state.receipts.all.total,
            summary_receipt: state => state.receipts.all.summary,
            selectedReceipt: state => state.receipts.selected,
            returns: state => state.returns.all.data,
            total_return: state => state.returns.all.total,
            summary_return: state => state.returns.all.summary,
            selectedReturn: state => state.returns.selected,
            recharges: state => state.recharges.all.data,
            total_recharge: state => state.recharges.all.total,
            summary_recharge: state => state.recharges.all.summary,
            loading: state => state.orders.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
        showLoadMoreOrder() {
            return (!this.orders || this.total_order > this.orders.length) && this.isMobile();
        }
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                if(this.isMobile()) return;
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_orders'] : []
                this.filter_data();
            },
            deep: true
        },
        receipt_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_receipts'] : []
                this.filter_data_receipt();
            },
            deep: true
        },
        return_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_returns'] : []
                this.filter_data_return();
            },
            deep: true
        },
        recharge_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_recharges'] : []
                this.filter_data_recharge();
            },
            deep: true
        }
    },
    methods: {
        isMobile() {
            if( screen.width <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        },
        refresh_data() {
            this.filter_data();
            this.filter_data_receipt();
            this.filter_data_return();
            this.filter_data_recharge();
        },
        filter_data(lazyload = false) {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            if(this.$route.query.orderid && this.$route.query.orderid != '') {
                param.filter.push({
                    column: "orders.id",
                    value: Number(this.$route.query.orderid),
                    condition: "equal",
                });
                this.$router.replace({'query': null});
            }
            if(this.selectedOrderStatus) {
                param.filter.push({
                    column: "status",
                    value: this.selectedOrderStatus,
                    condition: "s_equal",
                });
            }
            if(this.order_start_date) {
                param.filter.push({
                    column: "created_at",
                    value: this.order_start_date,
                    condition: "d_greater_than_or_equal",
                });
            }
            if(this.order_end_date) {
                param.filter.push({
                    column: "created_at",
                    value: this.order_end_date,
                    condition: "d_less_than_or_equal",
                });
            }
            if(!lazyload) {
                if(this.isMobile()) {
                    param.pagination.page = 1;
                }
                this.$store.dispatch("orders/getList", param);
            }
            else {
                param.lazyload = true;
                param.pagination.itemsPerPage = 30;
                this.$store.dispatch("orders/getList", param);
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        filter_data_receipt() {
            var param = {
                pagination: this.receipt_pagination,
                filter: this.filterReceiptConditions,
                quickFilter: this.quickFilterReceiptConditions
            };
            this.$store.dispatch("receipts/getList", param);
        },
        applyFilterReceipt(filterConditions) {
            let sortBy = this.receipt_pagination.sortBy
            let sortDesc = this.receipt_pagination.sortDesc
            this.receipt_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.receipt_pagination.sortBy = sortBy;
            this.receipt_pagination.sortDesc = sortDesc;
            this.filterReceiptConditions = filterConditions;
            this.filter_data_receipt();
        },
        quickFilterReceipt(filterConditions) {
            this.quickFilterReceiptConditions = filterConditions;
            this.filter_data_receipt();
        },
        filter_data_return() {
            var param = {
                pagination: this.return_pagination,
                filter: this.filterReturnConditions,
                quickFilter: this.quickFilterReturnConditions
            };
            this.$store.dispatch("returns/getList", param);
        },
        applyFilterReturn(filterConditions) {
            let sortBy = this.return_pagination.sortBy
            let sortDesc = this.return_pagination.sortDesc
            this.return_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.return_pagination.sortBy = sortBy;
            this.return_pagination.sortDesc = sortDesc;
            this.filterReturnConditions = filterConditions;
            this.filter_data_return();
        },
        quickFilterReturn(filterConditions) {
            this.quickFilterReturnConditions = filterConditions;
            this.filter_data_return();
        },
        filter_data_recharge() {
            var param = {
                pagination: this.recharge_pagination,
                filter: this.filterRechargeConditions,
                quickFilter: this.quickFilterRechargeConditions
            };
            this.$store.dispatch("recharges/getList", param);
        },
        applyFilterRecharge(filterConditions) {
            let sortBy = this.recharge_pagination.sortBy
            let sortDesc = this.recharge_pagination.sortDesc
            this.recharge_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.recharge_pagination.sortBy = sortBy;
            this.recharge_pagination.sortDesc = sortDesc;
            this.filterRechargeConditions = filterConditions;
            this.filter_data_recharge();
        },
        quickFilterRecharge(filterConditions) {
            this.quickFilterRechargeConditions = filterConditions;
            this.filter_data_recharge();
        },
        deleteItem(id) {
            this.$root.$emit('REQUEST_DELETE_DATA', id);
        },
        openItem: function (item) {
            this.order_options = [];
            this.$store.dispatch("orders/getDetail", item.id).then((ret) => {
                if (ret) {
                    this.selectedItem = ret;
                    this.selectedFirstOption = this.selectedItem.product_detail.options && this.selectedItem.product_detail.options.length > 0 ? this.selectedItem.product_detail.options[0].option_values[0] : {};
                    for (let i = 0; i < this.selectedItem.options.length; i++) {
                        const element = this.selectedItem.options[i];
                        let ops = element['option_id'] ? element['option_id'].split(',') : []
                        let vals = element['option_value_id'] ? element['option_value_id'].split(',') : []
                        this.order_options.push({
                            'id': element.id,
                            'product_id': this.selectedItem.product_detail.id,
                            'order_id': this.selectedItem.id,
                            'price': this.selectedItem.product_detail.price,
                            'first_op_id': ops.length > 0 ? Number(ops[0]) : 0, 
                            'first_id': vals.length > 0 ? Number(vals[0]) : 0, 
                            'last_op_id': ops.length > 1 ? Number(ops[1]) : 0, 
                            'last_id': vals.length > 1 ? Number(vals[1]) : 0, 
                            'qty': Number(element['qty']) 
                        });
                    }
                    this.dialogItem = true;
                }
            });
        },
        editItem() {
            this.$store.dispatch("orders/setDetail", {data: {id: this.selectedItem.id, options: this.order_options, action: 'update_options'}, id: this.selectedItem.id});
            this.dialogItem = false;
        },
        openReceiptDetail(id) {
            this.$store.dispatch("receipts/getDetail", id)
            this.dialogDetailReceipt = true;
        },
        openReturnDetail(id) {
            this.$store.dispatch("returns/getDetail", id)
            this.dialogDetailReturn = true;
        },
        printData() {
            if(!this.selectedReceipt) {
                sendErrorNotice('Lỗi không thể in hoá đơn.');
                return;
            }
            this.$store.dispatch("users/getDebt", {date: moment.parseZone(this.selectedReceipt.created_at).format(configs.SQL_DATE_FORMAT)}).then((debt) => {
                const frame_printing = print_export_receipt(this.selectedReceipt, this.selectedReceipt.receipt_products, debt);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            });
        },
        logout() {
            this.$root.$emit("APP_LOGOUT");
        },
        changePassword() {
            if(this.password != this.retype_password) {
                sendErrorNotice('Mật khẩu không khớp!');
                return;
            }
            if(this.password != '') {
                this.$store.dispatch("users/setDetail", {data: {'password': this.password}, id: this.$store.state.authentication.user.id});
            }
        },
        getNextOrder() {
            if (this.isMobile()) {
                this.filter_data(true);
            }
        },
        load_more_order() {
            this.pagination.page = this.pagination.page + 1;
            if(!this.orders || this.total_order > this.orders.length) {
                this.filter_data(true);
            }
        },
        updateOrderOption(first_op_id, first_opvl_id, last_op_id, last_opvl_id, value) {
            let item = _.find(this.order_options, {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id });
            if (item) {
                item['qty'] = Number(value);
            }
            else {
                this.order_options.push({'product_id': this.selectedItem.product_detail.id, 'order_id': this.selectedItem.id, 'price': this.selectedItem.product_detail.price, 'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id , 'qty': Number(value) });
            }
        },
        getOrderOption(first_id, last_id) {
            let item = _.find(this.order_options, {'first_id': first_id, 'last_id': last_id });
            return item ? item.qty : 0;
        },
        getFirstOptionQty(first_id) {
            return _.sumBy(this.order_options, (p) => {return p.first_id == first_id ? p.qty : 0});
        },
    },
    mounted () {
        this.$store.commit("orders/setList", {data: [], total: 0});
        this.getNextOrder();
        this.$store.dispatch("users/getDetail", this.customer_id);
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orders/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>